export default __webpack_public_path__ + "static/media/mystic_enhancement_ore.ff305093.png";